import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import {
  APPLY_TRANSPORT_ORDER_FILTERS,
  REQUEST_TRANSPORT_ORDER_FILTER,
  REQUEST_TRANSPORT_ORDERS,
  TRANSPORT_ORDER_STATUS,
} from '../../TransportOrders/constants';
import { Loader } from '../../../components/Loader';
import { HBox, VBox } from '../../../components/Box';
import { Card } from '../../../components/Card';
import { Cell, List, Row } from '../../../components/List';

import { CheckRound, IsOpen, CircleTimes, ArrowDown, Right } from '../../../components/Icon';
import { TasksProgressBar } from '../../KanbanBoards/components/TasksProgressBar';
import { REQUEST_VEHICLE_PROPERTIES, REQUEST_VEHICLE_PROPERTY_UPDATE, REQUEST_VEHICLE_TASKS } from '../constants';
import { selectUserId, selectWork, selectWorks } from '../../Api/selectors';
import { selectVehicleTasks } from '../selectors';
import { WS1_8_PreInspection } from '../../KanbanBoards/cells/WS/WS1_8_PreInspection';
import { selectActions } from '../../Actions/selectors';
import { fetchActions } from '../../Actions/actions';
import { REQUEST_ACTIONS } from '../../Actions/constants';
import { AppClientId } from '../../Shared/constants';
import LoadingDetailsPageCard from '../../../containers/App/Components/LoadingDetailsPageCard/LoadingDetailsPageCard';
import env from '../../../env';
import cn from 'classnames';
import styles from './CardVehicleTasks.module.css';
import { selectTransportOrderFilter, selectTransportOrders } from '../../TransportOrders/selectors';
import { KanbanVehicleRemarks } from '../../KanbanBoards/components/KanbanVehicleRemarks';
dayjs.extend(customParseFormat);

import { parseCompanyPhoneNumber } from '../../TransportOrders/helpers';
import {
  DEP_FINANCE,
  DEP_COMMERCE,
  DEP_WALSTREET,
  DEP_ADMINISTRATION,
  DEP_IT,
  DEP_WORKSHOP,
  DEP_ADMIN,
  DEP_TRANSPORT,
} from '../../../components/Permission/constants';
import { Permission } from '../../../components/Permission';
import { TaskRemarksTooltip } from './TaskRemarksTooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';
import { performAction } from '../../KanbanBoards/actions';
import { getRemarkType } from '../../KanbanBoards/cells/helpers/getRemarkType';
import { deleteVehicleProperty, fetchVehicleTasks } from '../actions';
import { VehicleProductTasksSection } from './VehicleProductTasksSection';

const Container = styled.div`
  font-size: 14px;


  .department {
    position: relative;
    height: 60px;
    width: 100%;
    padding: 5px;
    background-color: #eef1ef;
    border-radius: 0.375rem;
  }

  .tasks-list {
    margin: 10px;
  }
  align-items: center;
  .task-cell {
    height: 60px;
  }

  .toggle-icon {
    position: absolute;
    right: 5px;
  }
`;

const RemarkDataIconWrapper = styled.div`
  a {
    position: relative;
  }

  .alt-block {
    position: absolute;
    left: -240px;
    // right: 10px;
    // margin-left: 35px;
    // margin-top: -140px;
    left: -240px;
    // right: 10px;
    // margin-left: 35px;
    // margin-top: -140px;
    // top: ${props => (props.innerWidth < 768 ? '110%' : '100%')};

    z-index: 2;
    min-width: ${props => (props.innerWidth < 768 ? '150px' : '250px')};
    max-width: ${props => (props.innerWidth < 768 ? '150px' : '300px')};
    padding: 4px 8px;
    background-color: #cccccc;
    color: #6d727b;
    white-space: normal;
    text-align: left;
    border-radius: 5px;
  }
`;

const IconWrapper = styled.div`
  color: ${props => (props?.color === 'green' ? '#11ab79' : props?.color === 'orange' ? '#FC9629' : '#d50046')};
`;

const STATE = {
  tasks: [],
  isOpen: true,
};

const transformTaskNameToProperty = taskName => {
  if (!taskName) return '';

  // If the task name already starts with HOOI_NEW_TASK_, return as is
  if (taskName.startsWith('HOOI_NEW_TASK_')) {
    return taskName;
  }

  // Transform HOOI_NEW_ to HOOI_NEW_TASK_
  if (taskName.startsWith('HOOI_NEW_')) {
    return taskName.replace('HOOI_NEW_', 'HOOI_NEW_TASK_');
  }

  return taskName;
};

/* eslint-disable react/prefer-stateless-function */
class VehicleTasksCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    this.props.fetchActions();
  }

  renderActionModal() {
    return (
      <WS1_8_PreInspection
        vehicleDetails
        cell={{ vehicle: this.props.vehicle }}
        action={{ label: 'label', id: this.getActionIdByName('WS1_8_PreInspection') }}
        payload={{ task_name: 'task_spray' }}
        column={{ label: 'WS1_8_PreInspection' }}
        loggedUserId={this.props.loggedInUser}
      />
    );
  }

  deleteTask(task) {
    const taskPropertyName =
      env.clientId === AppClientId.HOOIKAMMER ? transformTaskNameToProperty(task.name) : `task_${task.name}`.toLowerCase();
    const taskDate = `${taskPropertyName}_date`;
    const taskRemarksPropertyName =
      env.clientId === AppClientId.HOOIKAMMER ? getRemarkType(taskPropertyName) : getRemarkType(task.name);

    this.props.deleteTask(taskPropertyName, taskDate, taskRemarksPropertyName, this.props.fetchVehicleTasks());
  }

  taskRemarksPropertyName(taskName) {
    return taskName?.split(' ').join('_');
  }

  getActionIdByName(name) {
    return this.props.actions?.find(a => a.functionName === name)?.id ?? null;
  }

  toggleDepartmentItemShow(department) {
    this.state[`show_${department}`]
      ? this.setState({ [`show_${department}`]: false })
      : this.setState({ [`show_${department}`]: true });
  }

  iconStatus(task) {
    if (task?.status == 'DONE') {
      return '2';
    }

    if (task?.status == 'TODO') {
      return '1';
    }

    return '0';
  }

  getTaskProgress(department) {
    const length = this.props.tasks[department]?.length;
    const tasksDone = this.props.tasks[department]?.filter(task => task?.status == 'DONE')?.length;
    const progress = tasksDone / length;
    return progress;
  }

  renderRemarks(task) {
    const transformedTaskName =
      env.clientId === AppClientId.HOOIKAMMER ? transformTaskNameToProperty(task?.name) : task?.name;
    return this.props.workRemarks ? (
      <Loader small />
    ) : (

      <KanbanVehicleRemarks
        readOnly
        toolTip
        taskName={transformedTaskName}
        vehicleId={this.props.vehicle.id}
        loggedUserId={this.props.loggedInUser}
        fetchedVehicle={this.props.vehicle}
      />
    );
  }

  renderRemarksTooltip(department, task) {
    return this.props.workRemarks ? (
      <Loader small />
    ) : (
      <TaskRemarksTooltip
        department={department}
        taskName={
          task?.name?.includes('_TASK')
            ? task.name
            : task?.name?.includes('HOOI_NEW_')
            ? task.name.replace('HOOI_NEW_', 'HOOI_NEW_TASK_')
            : task?.name
        }
        vehicleId={this.props.vehicle.id}
        loggedUserId={this.props.loggedInUser}
        fetchedVehicle={this.props.vehicle}
      />
    );
  }

  isHovered(hoveredOption, vehicleId) {
    this.setState({ isHover: hoveredOption, hoveredId: vehicleId });
  }

  render() {
    const vehicle = this.props.vehicle;
    if (this.props.work) return <LoadingDetailsPageCard />;

    return (
      <Card className={cn('vehicle-info-card info-card data', styles.card)}>
        <Container>
          <HBox className={styles.titleBox}>
            <h2 className="card-title mb-0 text-muted" style={{ whiteSpace: 'nowrap' }}>
              {this.lbl('vehicle.info.tasks.task_overview')}
            </h2>

            <div onClick={() => this.setState({ isOpen: !this.state.isOpen })}>
              <IsOpen />
            </div>
          </HBox>
          {this.state.isOpen && (
            <>
              <List>
                {(() => {
                  const filteredDepartments = Object.keys(this.props.tasks).filter(
                    department =>
                      (env.clientId === AppClientId.AUTOWIENTJES && department.includes('werkzaamheden_wientjes')) ||
                      (env.clientId === AppClientId.INDEWAL &&
                        [
                          'Technische_dienst',
                          'Walstreet',
                          'Importadministratie',
                          'Finance_inkoop',
                          'Finance_verkoop',
                          // 'Transport inkomend',
                          'Verkoopadministratie',
                          'Inkoopadministratie',
                          'Commercie',
                          // 'Transport uitgaand',
                        ].includes(department)) ||
                      (env.clientId === AppClientId.HILTERMANN &&
                        ['HILT_R_R', 'HILT_Logistiek', 'HILT_Debiteuren', 'HILT_Overig'].includes(department)) ||
                      (env.clientId === AppClientId.HOOIKAMMER && ['HOOIKAMMER'].includes(department)),
                  );

                  // if (filteredDepartments.length === 0) {
                  //   return (
                  //     <Row key="no-departments">
                  //       <Cell className="task-cell">
                  //         <HBox className="department" vCenter left>
                  //           <strong style={{ margin: '5px', width: '40%' }}>No departments available - Test Data</strong>
                  //         </HBox>
                  //         <List className="tasks-list">
                  //           <Row key="test-task-1">
                  //             <Cell>
                  //               <HBox>
                  //                 <HBox left>
                  //                   <div style={{ color: '#0BCF97' }}>
                  //                     <CheckRound />
                  //                   </div>
                  //                   Test Task 1
                  //                 </HBox>
                  //                 <div>Sample Remark 1</div>
                  //               </HBox>
                  //             </Cell>
                  //           </Row>
                  //           <Row key="test-task-2">
                  //             <Cell>
                  //               <HBox>
                  //                 <HBox left>
                  //                   <div style={{ color: '#d50046' }}>
                  //                     <CircleTimes />
                  //                   </div>
                  //                   Test Task 2
                  //                 </HBox>
                  //                 <div>Sample Remark 2</div>
                  //               </HBox>
                  //             </Cell>
                  //           </Row>
                  //         </List>
                  //       </Cell>
                  //     </Row>
                  //   );
                  // }

                  return filteredDepartments.map(department => (
                    <Row key={`task-${department}`}>
                      <Cell className="task-cell">
                        <RemarkDataIconWrapper>
                          <a
                            onMouseEnter={() => this.isHovered(department, this.props.vehicle?.id)}
                            onMouseLeave={() => this.isHovered(false)}
                          >
                            <HBox className="department" vCenter left>
                              <strong style={{ margin: '5px', width: '40%' }}>
                                {this.lbl(`vehicle.task.task_card.department.${department}`)}
                              </strong>

                              <div>
                                <TasksProgressBar progress={this.getTaskProgress(department)} width={130} />
                              </div>

                              <div className={'toggle-icon'} onClick={() => this.toggleDepartmentItemShow(department)}>
                                <IsOpen />
                              </div>
                            </HBox>

                            {department &&
                              this.state.isHover === department &&
                              this.state.hoveredId === this.props.vehicle?.id &&
                              this.renderRemarksTooltip(department)}
                          </a>
                        </RemarkDataIconWrapper>
                        {this.state[`show_${department}`] && (
                          <List className="tasks-list">
                            {this.props.tasks[department]?.map((task, index) => (
                              <Row key={task?.name}>
                                <Cell>
                                  <HBox>
                                    <HBox left>
                                      {this.iconStatus(task) === '1' ? (
                                        <div
                                          style={{ color: '#d50046' }}
                                          onClick={() => this.toggleDepartmentItemShow(department)}
                                        >
                                          <CircleTimes />
                                        </div>
                                      ) : (
                                        <div
                                          style={{ color: '#0BCF97' }}
                                          onClick={() => this.toggleDepartmentItemShow(department)}
                                        >
                                          <CheckRound />
                                        </div>
                                      )}

                                      
                                      
                                      {
                                          env.clientId !== AppClientId.INDEWAL && (

                                          (env.clientId === AppClientId.HILTERMANN || env.clientId === AppClientId.HOOIKAMMER) &&
                                          task?.name?.startsWith('product_task_other_task_')
                                            ? vehicle?.[`product_task_other_${task.name.split('_').pop()}_title`]
                                            : this.lbl(`vehicle.property.${task?.name}`)

                                          )
                                          
                                        }



                                      {env.clientId != AppClientId.HILTERMANN &&
                                        env.clientId != AppClientId.HOOIKAMMER &&
                                        this.lbl(`vehicle.details.task_card.task.name.${task?.name?.toLowerCase()}`)}

                                      {task?.name == 'HOOI_NEW_de_sticker' && vehicle?.HOOI_NEW_TASK_de_sticker_hours && (
                                        <div> &nbsp; Uren: {vehicle?.HOOI_NEW_TASK_de_sticker_hours}</div>
                                      )}
                                      {task?.name == 'HOOI_NEW_additional_interior_cleaning' &&
                                        vehicle?.HOOI_NEW_TASK_additional_interior_cleaning_hours && (
                                          <div>
                                            {' '}
                                            &nbsp; Uren: {vehicle?.HOOI_NEW_TASK_additional_interior_cleaning_hours}
                                          </div>
                                        )}
                                      {task?.name == 'HOOI_NEW_additional_cleaning_costs' &&
                                        vehicle?.HOOI_NEW_TASK_additional_cleaning_costs_hours && (
                                          <div> &nbsp; Uren: {vehicle?.HOOI_NEW_TASK_additional_cleaning_costs_hours}</div>
                                        )}
                                      {task?.name == 'HOOI_NEW_disposal_debris_waste' &&
                                        vehicle?.HOOI_NEW_TASK_disposal_debris_waste_hours && (
                                          <div> &nbsp; Uren: {vehicle?.HOOI_NEW_TASK_disposal_debris_waste_hours}</div>
                                        )}
                                      {task?.name == 'HOOI_NEW_polish' && vehicle?.HOOI_NEW_TASK_polish_hours && (
                                        <div> &nbsp; Uren: {vehicle?.HOOI_NEW_TASK_polish_hours}</div>
                                      )}
                                      {task?.name == 'HOOI_NEW_damage_repair' &&
                                        vehicle?.HOOI_NEW_TASK_damage_repair_hours && (
                                          <div> &nbsp; Uren: {vehicle?.HOOI_NEW_TASK_damage_repair_hours}</div>
                                        )}
                                      {task?.name == 'HOOI_NEW_make_car_drivable' &&
                                        vehicle?.HOOI_NEW_TASK_make_car_drivable_hours && (
                                          <div> &nbsp; Uren: {vehicle?.HOOI_NEW_TASK_make_car_drivable_hours}</div>
                                        )}
                                         {task?.name == 'HOOI_NEW_TASK_refuel' &&
                                        vehicle?.HOOI_NEW_TASK_refuel_charging_litres && (
                                          <div> &nbsp; Liters: {vehicle?.HOOI_NEW_TASK_refuel_charging_litres}</div>
                                        )}
                                         {task?.name == 'HOOI_NEW_TASK_charge' &&
                                        vehicle?.HOOI_NEW_TASK_SOC_before_charge && (
                                          <div> &nbsp; Start SOC: {vehicle?.HOOI_NEW_TASK_SOC_before_charge}</div>
                                        )}

                                      {/* {task?.name && vehicle?.[`${task.name}_remarks`] && (
                                        <span
                                          style={{ marginLeft: '8px', cursor: 'pointer', color: '#555' }}
                                          title={vehicle[`${task.name}_remarks`]}
                                        >
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            height="1em"
                                            viewBox="0 0 512 512"
                                            fill="currentColor"
                                          >
                                            <path d="M256 0C114.84 0 0 114.84 0 256s114.84 256 256 256 256-114.84 256-256S397.16 0 256 0zm0 96a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm48 320h-96v-48h24v-96h-24v-48h72v144h24v48z"/>
                                          </svg>
                                        </span>
                                      )} */}
                                    </HBox>
                                    <HBox vCenter right gap={'8px'}>
                                      <RemarkDataIconWrapper>
                                        <a
                                          onMouseEnter={() => this.isHovered(task?.name, this.props.vehicle?.id)}
                                          onMouseLeave={() => this.isHovered(false)}
                                        >
                                          {this.renderRemarks(task)}

                                          {task?.name &&
                                            this.state.isHover === task?.name &&
                                            this.state.hoveredId === this.props.vehicle?.id &&
                                            this.renderRemarksTooltip(null, task)}
                                        </a>
                                      </RemarkDataIconWrapper>
                                      {this.iconStatus(task) === '1' && (
                                        <IconWrapper color="red">
                                          <div
                                            onClick={evt => {
                                              evt.stopPropagation();

                                              this.deleteTask(task);
                                            }}
                                            style={{ cursor: 'pointer' }}
                                          >
                                            <FontAwesomeIcon icon={faTimesCircle} />
                                          </div>
                                        </IconWrapper>
                                      )}
                                    </HBox>
                                  </HBox>
                                </Cell>
                              </Row>
                            ))}
                          </List>
                        )}
                      </Cell>
                    </Row>
                  ));
                })()}
                {this.props.transportOrders?.length > 0 && (
                  <Row key={`transport`}>
                    <Cell className="task-cell">
                      <HBox className="department" vCenter left>
                        <strong style={{ margin: '5px', width: '40%' }}>
                          {this.lbl(`vehicle.task.task_card.department.transport`)}
                        </strong>

                        <div>
                          <TasksProgressBar
                            progress={
                              this.props.transportOrders?.length
                                ? this.props.transportOrders.filter(t => t.status === 'initiated' || t.status === 'done')
                                    .length / this.props.transportOrders.length
                                : 0
                            }
                            width={130}
                          />{' '}
                        </div>

                        <div className={'toggle-icon'} onClick={() => this.toggleDepartmentItemShow('transport')}>
                          <IsOpen />
                        </div>
                      </HBox>

                      {this.state[`show_transport`] && (
                        <>
                          {this.props.transportOrders?.map(t => (
                            <List className="tasks-list" key={`transport-${t.id}`}>
                              <Row>
                                <Cell>
                                  <HBox>
                                    <HBox left>
                                      {t?.status === 'requested' ? (
                                        <div style={{ color: '#d50046' }}>
                                          <CircleTimes />
                                        </div>
                                      ) : t?.status === 'initiated' ? (
                                        <div style={{ color: 'orange' }}>
                                          <CheckRound />
                                        </div>
                                      ) : (
                                        <div style={{ color: '#0BCF97' }}>
                                          <CheckRound />
                                        </div>
                                      )}

                                      {t?.type == 'incoming' ? (
                                        <span>
                                          {t?.individual ? 'Los ' : ''} Inkomend transport (
                                          {this.lbl(`vehicle.property.status.${t?.status}`)})
                                        </span>
                                      ) : (
                                        <span>
                                          {t?.individual ? 'Los ' : ''}Uitgaand transport (
                                          {this.lbl(`vehicle.property.status.${t?.status}`)})
                                        </span>
                                      )}
                                    </HBox>
                                  </HBox>
                                </Cell>
                              </Row>
                            </List>
                          ))}
                        </>
                      )}
                    </Cell>
                  </Row>
                )}
              </List>

              {env.clientId !== AppClientId.HILTERMANN &&
                env.clientId !== AppClientId.HOOIKAMMER &&
                this.renderActionModal()}
              <VehicleProductTasksSection
                vehicleId={this.props.vehicle?.id}
                onAdded={this.props.onAdded ? this.props.onAdded.bind(this) : undefined}
              />
            </>
          )}
        </Container>
      </Card>
    );
  }
}

VehicleTasksCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks(REQUEST_VEHICLE_TASKS, REQUEST_ACTIONS, REQUEST_VEHICLE_TASKS, REQUEST_VEHICLE_PROPERTIES),
    tasks: selectVehicleTasks(),
    transportOrders: selectTransportOrders(),
    actions: selectActions(),
    loggedInUser: selectUserId(),
    workRemarks: selectWork(`${REQUEST_VEHICLE_PROPERTY_UPDATE}`),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    setTransportOrderFilter: () => {
      dispatch(
        updateTransportOrderFilter(
          {
            key: 'vehicleId',
            value: [vehicle?.id?.toString()?.toLowerCase()],
            label: ['vehicleId'],
            type: 'single',
          },
          { getDeleted: true },
        ),
      );
    },
    applyFilter: () => {
      dispatch(applyTransportOrderFilters());
    },
    setSearchString(text) {
      dispatch(applyTransportOrderFilters());
    },
    fetchActions() {
      dispatch(fetchActions());
    },
    fetchVehicleTasks(callback) {
      dispatch(fetchVehicleTasks(ownProps.vehicle?.id, callback));
    },
    // deleteTaskWithPerformer(actionId, vehicleId, payload) {
    //   dispatch(performAction(actionId, vehicleId, payload, () => {}, true));
    // },
    deleteTask(task, date, remarks, cb) {
      dispatch(deleteVehicleProperty(ownProps.vehicle.id, task));
      dispatch(deleteVehicleProperty(ownProps.vehicle.id, date));
      dispatch(deleteVehicleProperty(ownProps.vehicle.id, remarks, cb));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleTasksCard = compose(withConnect, withRouter)(VehicleTasksCardComp);
